import { Component, HostBinding, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-dynamic-fields-menu',
  templateUrl: './dynamic-fields-menu.component.html',
  styleUrls: ['./dynamic-fields-menu.component.scss'],
})
export class DynamicFieldsMenuComponent {
  @Input() items: MenuItem[] = [];

  // nasconde anche la colonna della grid (non solo il contenuto) quando non ci sono campi
  @HostBinding('class.hidden') get isHidden(): boolean {
    return this.items.length === 0;
  }

  filterText = '';

  get filteredItems(): MenuItem[] {
    const query = this.filterText.trim().toLowerCase();
    if (!query) {
      return this.items;
    }
    return this.items.filter(item => {
      const label = item.label?.toLowerCase() ?? '';
      const description = (item.tooltipOptions?.tooltipLabel as string | undefined)
        ?.toLowerCase()
        ?.trim();
      return label.includes(query) || !!description?.includes(query);
    });
  }
}
